import angular from "angular";

function getVoltageRangeByBeaconType(beaconType) {
    switch (beaconType) {
        case 'Sentinel 200 Flex':
        case 'Sentinel Scorpion':
        case 'Trackonomy':
            return [2.5, 3];
        default:
            return [2.1, 3.5];
    }
}

const batteryPercentageService = () => ({
    calc: (voltage, beaconType) => {
        if (voltage == null) {
            return null;
        }

        const [minVoltage, maxVoltage] = getVoltageRangeByBeaconType(beaconType);

        const clampedVoltage = Math.max(minVoltage, Math.min(maxVoltage, voltage));
        const percentage = ((clampedVoltage - minVoltage) / (maxVoltage - minVoltage)) * 100;

        return Math.round(percentage * 100) / 100;
    }
});

angular.module('ui-common').factory('BatteryPercentageService', batteryPercentageService);
